module.exports = __webpack_public_path__ + "ipm.236cbf3b551b4d8dba95.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ipm.eot
// module id = 87
// module chunks = 2